<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <form-select v-model="query.type" id="type" label="項目">
                    <div is="option" value="3-4">3-4</div>
                </form-select>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>項目</th>
                            <th>條件</th>
                            <th>點數</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.PaSetID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.PaSetID" /></td>
                        <td data-th="項目">{{item.Type}}</td>
                        <td data-th="條件">
                            <b-button size="sm" variant="link" @click="edit(item.PaSetID)">
                                ><span v-if="item.MinEqual">=</span>{{item.Min}}
                            </b-button>
                        </td>
                        <td data-th="點數">{{item.Score}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload"></Detail>
    </page-main>
</template>

<script>
    import Detail from './pasetDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'paset',
        api: '/api/paset/',
        components: { Detail },
    });
</script>

<style>
</style>